import { step1, step2, step3, step4, step5, step6 } from "./data";
import { Box, Container, Typography } from "@mui/material";
import StepButtons from "../StepButtons";
import { useEffect, useRef, useState } from "react";
import SupportFor from "./SupportFor";
import Step from "../Step";
import Testimonials from "./Testimonials";
import Specialists from "../../../specialist/index";
import { useDispatch } from "react-redux";
import { clearQuestionnaire, setQuestionnaire } from "../../../../../redux/user-slices/auth.slice";

function Personal({ setStarted }) {
  const formDataRef = useRef({});
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(0);
  const stepsConfig = [
    { steps: step1 },
    { steps: formDataRef?.current?.country === "United States" ? step2 : step3 },
    { steps: formDataRef?.current?.country === "United States" ? step4 : step5 },
    { steps: step6 },
    {},
  ];
  useEffect(() => {
    dispatch(clearQuestionnaire());
    // eslint-disable-next-line
  }, []);
  const handleNext = () => {
    if (activeStep < stepsConfig?.length - 1) {
      setTimeout(() => {
        setActiveStep((prevStep) => prevStep + 1);
      }, 500);
    }
    if (activeStep === stepsConfig?.length - 1) {
      setStarted(true);
    }
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };
  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);
    formDataRef.current = {
      ...formDataRef.current,
      ...formData,
    };
    dispatch(setQuestionnaire(formDataRef.current));
    if (activeStep >= 4) {
      setStarted(true);
    }
    handleNext();
  };

  return (
    <>
      <Box component="section" sx={{ py: { xs: 5, lg: 10 } }}>
        <Container maxWidth={false} fixed>
          <Box sx={{ maxWidth: "900px", mx: "auto" }}>
            <Typography
              mb={5}
              fontWeight="600"
              textAlign="center"
              variant="bodyNormal"
              color="other.color1"
            >
              This quick assessment helps us understand your unique challenges
              and connect you with the right specialists and resources. Your
              answers are private and secure.
            </Typography>
          </Box>
          <Box
            sx={{ maxWidth: "600px", mx: "auto" }}
            component="form"
            onSubmit={handleSubmit}
          >
            {activeStep <= 3 ? (
              stepsConfig[activeStep] && (
                <Step
                  nextBtnFun={handleNext}
                  index={activeStep}
                  formData={formDataRef}
                  steps={stepsConfig[activeStep].steps}
                />
              )
            ) : (
              <SupportFor supportFor={formDataRef?.current?.supportFor} />
            )}
            <StepButtons
              backBtn={activeStep !== 0}
              skipBtn={activeStep <= stepsConfig?.length}
              isLastStep={activeStep === stepsConfig?.length - 1}
              nextBtnFun={handleNext}
              backBtnFun={handleBack}
            />
          </Box>
        </Container>
      </Box>
      <Specialists />
      <Testimonials />
    </>
  );
}

export default Personal;
